// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"825a0b30","464":"5600cafc","787":"5128b469"}[chunkId] + ".chunk.js";
};